export const functionality = {
  schoolUniform: {
    date:  new Date(2026, 5, 8, 9, 0, 0)
  }
}

export const isActive = (func) =>  new Date() >= func.date;